import { config } from '@/config';
import {
  handleSaveWidgetSettings,
  handleSaveWidgetTextDefaultDetail,
  widgetSettingSelector,
  widgetTextDefaultDetailSelector,
} from '@/redux/slice/widget.slice';
import { BlockStack, TextField } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const WidgetTextCommon = () => {
  const { t } = useTranslation('widget_settings');
  const widgetTextDefaultDetail = useSelector(widgetTextDefaultDetailSelector);
  const dispatch = useDispatch();
  const CUSTOM_MESSAGE_SHOPS = ['lune-sans-blocks.myshopify.com', 'sonlh-dev.myshopify.com', 'quanganh-test.myshopify.com'];
  const widgetSettings = useSelector(widgetSettingSelector);
  return (
    <BlockStack gap={'300'}>
      <TextField
        label={t('widgetDesign.textField.headingTitle')}
        autoComplete="off"
        value={widgetTextDefaultDetail.headerTitle}
        onChange={(value: string) => dispatch(handleSaveWidgetTextDefaultDetail({ headerTitle: value }))}
      />
      <TextField
        label={t('widgetDesign.textField.additional')}
        autoComplete="off"
        value={widgetTextDefaultDetail.additionalMessage}
        placeholder={t('widgetDesign.textField.additionalPlaceholder')}
        onChange={(value: string) => dispatch(handleSaveWidgetTextDefaultDetail({ additionalMessage: value }))}
      />
      {CUSTOM_MESSAGE_SHOPS.includes(config.shop) && (
        <TextField
          label={t('customMessage.label')}
          autoComplete="off"
          helpText={t('customMessage.helpText')}
          value={widgetSettings.customMessage}
          onChange={(value) => {
            dispatch(handleSaveWidgetSettings({ customMessage: value }));
          }}
        />
      )}
    </BlockStack>
  );
};
